import { api } from "api/apiHelper";
import { Endpoints } from "api/apiConst";
// import { ModerationsData } from "features/moderation/types/ModerationsData";

export const getModerations = async (params?: object) => {
  const { current, pageSize } = params as any;
  const config = {
    params: {
      page: current,
      per: pageSize,
    },
  };

  console.log(config);
  // current: 1,
  // pageSize: 10,

  const response = await api.get(Endpoints.MODERATION, config);
  console.log(response);
  return response.data;
};

export const updateModeration = async (params?: object) => {
  console.log(params);
  const response = await api.patch(Endpoints.MODERATION, params);
  console.log(response);
  return response.data;
};
